import React from 'react';

import Blank from '../../containers/Blank'
const BlankView = () => {
    return(


            <Blank/>

        )}

export default BlankView;
